import { render, staticRenderFns } from "./NavigationMenuForMobile.vue?vue&type=template&id=5d2657b0&"
import script from "./NavigationMenuForMobile.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuForMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports